import { render, staticRenderFns } from "./commonGoodsList.vue?vue&type=template&id=b1312942&scoped=true"
import script from "./commonGoodsList.vue?vue&type=script&lang=ts"
export * from "./commonGoodsList.vue?vue&type=script&lang=ts"
import style0 from "./commonGoodsList.vue?vue&type=style&index=0&id=b1312942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1312942",
  null
  
)

export default component.exports